import { Box, Button, Card, Collapse, Grid, IconButton, List, ListItemButton, ListItemIcon, ListItemText, TextField, Tooltip, Typography } from '@mui/material'
import HeaderGestorConfigs from '../../../../utils/headerGestorConfigs'
// import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../../../services/api';
import Loading from '../../../../load/loading';
import LoadingShort from '../../../../load/loadingShort';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import compressImage from '../../../../services/compressImage';
import CloseIcon from '@mui/icons-material/Close';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { Avatar } from '@material-ui/core';
import AvaliacaoAnalitica from './avaliacaoAnalitica';
import DocumentosEmitidos from './documentosEmitidos';
import Date from '../../../../utils/date';
import InfoFieldGroup from '../../../../utils/InfoField/InfoFieldGroup';


export default function AnaliseProduto({ solicitacaoAnalise, avaliacaoAnalitica, setAvaliacaoAnalitica }) {
    const user = useSelector(state => state.account.user);
    const { id } = useParams()
    const { produtoId } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    // const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [load, setLoad] = useState(false)
    const [loadAddImage, setLoadAddImage] = useState(false)
    const [produto, setProduto] = useState('')
    const [imageDissolucao, setImageDissolucao] = useState([]);
    const [imageTesteVisual, setImageTesteVisual] = useState([]);
    const [imageTesteCromato, setImageTesteCromato] = useState([]);
    const [imageTestePH, setImageTestePH] = useState([]);
    const [openImagensCapturadas, setOpenImagensCapturadas] = useState(false);
    const [refresh, setRefresh] = useState('');

    const [editDados, setEditDados] = useState('');
    const [isEdit, setIsEdit] = useState('');

    useEffect(() => {
        api.get(`/producto/${produtoId}`)
            .then(response => {
                // console.log(response)
                setProduto(response.data.producto);
            }).catch(err => { });
    }, [id, setProduto, refresh])

    useEffect(() => {
        if (Array.isArray(avaliacaoAnalitica?.testesDissolucao)) {
            avaliacaoAnalitica.testesDissolucao.forEach((teste) => {
                if (teste?.imagens?.length) {
                    api.post('/get-imagebase64', { urls: teste.imagens })
                        .then(res => {
                            // setImageDissolucao((prev) => [...prev, ...res.data.images]);
                            setImageDissolucao((prev) => Array.from(new Set([...prev, ...res.data.images])));
                        })
                        .catch(err => 'console.log(err)');
                }
            });
        }
        if (Array.isArray(avaliacaoAnalitica?.cromatografia)) {
            const todasImagens = avaliacaoAnalitica.cromatografia
                .flatMap(teste => teste?.imagens?.length ? teste.imagens : []);

            if (todasImagens.length) {
                api.post('/get-imagebase64', { urls: todasImagens })
                    .then(res => setImageTesteCromato((prev) => Array.from(new Set([...prev, ...res.data.images]))))
                    .catch(err => 'console.log(err)');
            }
        }

        if (Array.isArray(avaliacaoAnalitica?.inspeccaoVisualFisica)) {
            const todasImagens = avaliacaoAnalitica.inspeccaoVisualFisica
                .flatMap(teste => teste?.imagens?.length ? teste.imagens : []);

            if (todasImagens.length) {
                api.post('/get-imagebase64', { urls: todasImagens })
                    .then(res => setImageTesteVisual((prev) => Array.from(new Set([...prev, ...res.data.images]))))
                    .catch(err => 'console.log(err)');
            }
        }

        if (Array.isArray(avaliacaoAnalitica?.testesPH)) {
            const todasImagens = avaliacaoAnalitica.testesPH
                .flatMap(teste => teste?.imagens?.length ? teste.imagens : []);

            if (todasImagens.length) {
                api.post('/get-imagebase64', { urls: todasImagens })
                    .then(res => setImageTestePH((prev) => Array.from(new Set([...prev, ...res.data.images]))))
                    .catch(err => 'console.log(err)');
            }
        }

    }, [avaliacaoAnalitica, produtoId, isEdit]);


    async function postImage(e) {
        setLoadAddImage(true)
        let imageComprimida = await compressImage(e.target.files[0])

        const formData = new FormData();
        formData.append('imagem', imageComprimida);
        formData.append('productoId', produto?._id);
        formData.append('userId', user?._id);

        await api.patch(`/producto/add-image`, formData)
            .then(response => {
                setProduto(response.data.producto);
                setLoadAddImage(false)
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Amostra adicionada.!' },
                });

            }).catch(err => {
                setLoadAddImage(false)
            })
    }

    const CaptureImage = () => {
        return (
            <>
                <IconButton size='large'  >
                    {loadAddImage ? <LoadingShort />
                        :
                        <label htmlFor="capitureImage" >
                            <Tooltip title="Carregar imagens da amostra">
                                <CameraAltIcon />
                            </Tooltip>
                        </label>
                    }
                </IconButton>
                <input accept="image/png, image/jpg, image/jpeg" type="file" name="foto" id="capitureImage" style={{ display: 'none' }} onChange={postImage} />
            </>
        )
    }
    // console.log(avaliacaoAnalitica)

    const submitEdit = async () => {

        setLoad(true)
        setMessageError('')

        await api.put('/producto/edit', { ...editDados, productoId: produtoId, 'userId': user?._id ?? '' })
            .then(res => {
                setLoad(false)
                setIsEdit(false);


            }).catch(err => {
                // console.log(err)
                setLoad(false)
                setMessageError(err.response.data.message)
            })
    }

    return (
        produto ?
            <>
                <Card style={{ padding: 20, position: 'relative' }}>

                    <IconButton title="fechar" style={{ position: 'absolute', right: 5, fontWeight: 'bold' }} onClick={() => { navigate(`/admin/dcqmts/gest/solicitacao-de-analise/${solicitacaoAnalise?._id}`) }}> <CloseIcon /></IconButton>

                    {/* {messageSuccess && <MessageSuccess message={messageSuccess} />} */}
                    {messageError && <MessageError message={messageError} />}

                    <HeaderGestorConfigs
                        menu={false}
                        configArea={''}
                        title={'PRODUTO'}
                    />

                    <InfoFieldGroup
                        editable={true}
                        submit={submitEdit}
                        data={editDados}
                        // handleChange={handleChange}
                        setIsEdit={setIsEdit}
                        isEdit={isEdit}
                        load={load}
                        fields={
                            [
                                { label: 'Estado', value: produto?.status, editable: false, },
                                { label: 'Nome do Produto', value: produto?.nome, key: 'nome', onChange: (v) => setEditDados({ ...editDados, nome: v.target.value }) },
                                { label: 'Nome Comercial', value: produto?.nomeComercial, key: 'nomeComercial', onChange: (v) => setEditDados({ ...editDados, nomeComercial: v.target.value }) },
                                { label: 'Principio Activo', value: produto?.principioActivo, key: 'principioActivo', onChange: (v) => setEditDados({ ...editDados, principioActivo: v.target.value }) },
                                { label: 'Forma Farmacêutica', value: produto?.formaFarmaceutica, key: 'formaFarmaceutica', onChange: (v) => setEditDados({ ...editDados, formaFarmaceutica: v.target.value }) },
                                { label: 'Descrição das Substâncias Activas', value: produto?.descicaoSubstanciasActivas, key: 'descicaoSubstanciasActivas', onChange: (v) => setEditDados({ ...editDados, descicaoSubstanciasActivas: v.target.value }) },
                                // {label: 'Categória', value: produto?.categoria, key: 'categoria', type: 'select', options: categoriaOptions, onChange: (v) => setEditDados({...editDados, categoria: v.target.value }) },
                                { label: 'Tipo de Produto', value: produto?.tipo, key: 'tipo', onChange: (v) => setEditDados({ ...editDados, tipo: v.target.value }) },
                                { label: 'Lote', value: produto?.lote, key: 'lote', onChange: (v) => setEditDados({ ...editDados, lote: v.target.value }) },
                                { label: 'TeorBase (g)', value: produto?.teorBaseG, key: 'teorBaseG', onChange: (v) => setEditDados({ ...editDados, teorBaseG: v.target.value }) },
                                { label: 'Dosagem/Concentração', value: produto?.dosagemConcentracao, key: 'dosagemConcentracao', onChange: (v) => setEditDados({ ...editDados, dosagemConcentracao: v.target.value }) },
                                { label: 'Fabricante / Laboratório', value: produto?.fabricante, key: 'fabricante', onChange: (v) => setEditDados({ ...editDados, fabricante: v.target.value }) },
                                { label: 'Endereço do Fabricante', value: produto?.enderecoFabricante, key: 'enderecoFabricante', onChange: (v) => setEditDados({ ...editDados, enderecoFabricante: v.target.value }) },
                                { label: 'Data de Fabrico', value: isEdit ? produto?.dataFabrico?.substring(0, 10) : <Date date={produto?.dataFabrico} />, type: 'date', key: 'dataFabrico', onChange: (v) => setEditDados({ ...editDados, dataFabrico: v.target.value }) },
                                { label: 'Data de Validade', value: isEdit ? produto?.dataValidade?.substring(0, 10) : <Date date={produto?.dataValidade} />, type: 'date', key: 'dataValidade', onChange: (v) => setEditDados({ ...editDados, dataValidade: v.target.value }) },
                                { label: 'Quantidade de Amostras Submetidas', value: produto?.qtdAmostraSubmetidas, editable: false, key: 'qtdAmostraSubmetidas', onChange: (v) => setEditDados({ ...editDados, qtdAmostraSubmetidas: v.target.value }) },
                                { label: 'Quantidade de Amostras Recebida', value: produto?.quantidadeAmostras, key: 'quantidadeAmostras', onChange: (v) => setEditDados({ ...editDados, quantidadeAmostras: v.target.value }) },
                                { label: 'Adicionar imagem', value: <CaptureImage />, editable: false },
                            ]
                        } />


                    {/* {solicitacaoAnalise?.resultado !== "Aprovado" &&
                        <CaptureImage />
                    } */}

                    {/* LISTA DE IMAGENS DE AMOSTRAS CAPTURADAS */}
                    <List
                        sx={{ width: '100%', minWidth: '100%', bgcolor: 'background.paper' }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                    >
                        <ListItemButton onClick={() => setOpenImagensCapturadas(!openImagensCapturadas)}>
                            <ListItemIcon>
                                {produto.imagens.map((foto, index) =>
                                    index < 10 &&
                                    <Avatar key={index} variant='square' id={index} src={foto} style={{ margin: 5 }} />
                                )}
                            </ListItemIcon>
                            <ListItemText primary="IMAGENS DE AMOSTRAS" />
                            {openImagensCapturadas ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>


                        <Collapse in={openImagensCapturadas} timeout="auto" unmountOnExit>

                            {produto.imagens.map((foto, index) =>
                                <div key={index} style={{ position: 'relative' }}>
                                    <img id={index} src={foto} style={{ marginBottom: 10 }} />
                                </div>
                            )}
                        </Collapse>
                    </List>
                </Card>

                <br />
                {produto?.docs?.receitaMedica &&
                    <Card>
                        <Typography variant="subtitle1" style={{ margin: 20 }}>
                            Documento anexado:
                            {/* <br /> */}
                            <a target="_blank" href={produto?.docs?.receitaMedica} >{produto?.docs?.receitaMedica ? 'Anexo' : ''} </a>
                            <br />
                        </Typography>
                        <embed
                            id="pdfIframecontroleQualidadePruduto"
                            title={`PDF Viewer`}
                            src={[produto?.docs?.receitaMedica]}
                            width="100%"
                            height="700px"
                            style={{ border: 'none' }}
                        />
                    </Card>
                }

                <AvaliacaoAnalitica
                    produto={produto}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    solicitacaoAnalise={solicitacaoAnalise}
                    avaliacaoAnalitica={avaliacaoAnalitica}
                    setAvaliacaoAnalitica={setAvaliacaoAnalitica}
                />

                {avaliacaoAnalitica?.relatorioEmited &&
                    <DocumentosEmitidos
                        avaliacaoAnalitica={{ ...avaliacaoAnalitica, producto: produto }}
                        imageDissolucao={imageDissolucao}
                        imageTestePH={imageTestePH}
                        imageTesteVisual={imageTesteVisual}
                        imageTesteCromato={imageTesteCromato}
                    />
                }

            </>
            :
            <Loading text={'Acarregar produto..'} />
    )
}
